import { render, staticRenderFns } from "./SIPRoutesDetail.vue?vue&type=template&id=4e4020f0"
import script from "./SIPRoutesDetail.vue?vue&type=script&lang=ts"
export * from "./SIPRoutesDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports